import React from 'react';
import nanoid from 'nanoid';
import ReactTooltip from 'ati-ui-react/components/ReactTooltip';
import useWindowSize from 'hooks/useWindowSize';
import { RatingStyles } from './RatingStyles';

const declineFirm = (count) => {
  if (count % 10 === 1 && count % 100 !== 11) {
    return 'фирмы';
  }
  return 'фирм';
};

// FIXME: куски чужого кода, отрефакторить
function Rating({ account, advert, ml }) {
  const [width] = useWindowSize();

  const claims = account?.claims_count;
  const recommendations = account?.recommendation_count;
  const badFirms = account?.bad_partner_firms_count;
  const badCount = account?.bad_partner_mentions_count;
  const id = nanoid();

  if (badCount || claims || recommendations) {
    const reviewTooltipText = [
      recommendations > 0 ? `Рекомендаций: ${recommendations}` : null,
      claims > 0 ? `Претензий: ${claims}` : null,
      badFirms > 0
        ? `Упоминаний на форуме «Недобросовестные партнеры»: ${
            !!badCount && badCount
          } от ${badFirms} ${declineFirm(badFirms)}`
        : null,
    ];

    return (
      <RatingStyles ml={ml} onClick={(e) => e.stopPropagation()}>
        <span className="reviews" data-tip data-for={`${id}_review`}>
          {recommendations > 0 && <span className="green">{`р${recommendations}`}</span>}
          {((recommendations > 0 && claims > 0) || (recommendations > 0 && badCount > 0)) && ', '}
          {claims > 0 && <span className="red">{`п${claims}`}</span>}
          {claims > 0 && badCount > 0 && ', '}
          {badCount > 0 && (
            <span className={`${badCount < 3 ? 'orange' : 'red'}${badCount > 5 ? ' bold' : ''}`}>
              {`нп${badCount}`}
            </span>
          )}
        </span>
        {width > 1023 && (
          <ReactTooltip data-tip id={`${id}_review`} effect="solid" aria-haspopup="true">
            {reviewTooltipText.filter(Boolean).join(', ')}
          </ReactTooltip>
        )}
      </RatingStyles>
    );
  }

  return '';
}

export default Rating;
